import React from 'react';


const Privacy = () => {
    return (
        <div>
            Thank you for choosing Xosphere! This Privacy Policy describes what information
            Xosphere, Inc. ("Xosphere"", "We", "Us", "Our") collects, stores, uses,
            and shares from and about users of this of this website and associated products and
            services (collectively, "Services").
            By using Our Services, you expressly consent to the collection, storage, use and
            disclosure of your information as described
            in this Privacy Policy. If you disagree with anything in this Privacy Policy, please
            do not use Our Services. <br/>

            <br/><b>Information Collected</b><br/>
            <br/>

            We will collect and retain the personal information you provide to Us voluntarily,
            such as your
            name and email address when you create an account to use the Services or when you
            give Us feedback or contact Us via email.<br/>
            <br/>
            Our Services collect non personally identifying information from and about you when
            you use the Services.
            Like most websites, We use common internet technologies such as cookies, pixels, and
            beacons to keep
            track of user interactions with the Services, including where you navigate, what you
            click on, how long
            you stay engaged, and the content you visit. When you use Our Services, We may also
            collect information
            such as your browser and device information, language preferences, associate the
            different devices you
            use to access the services, and other traffic and usage related data.<br/>
            <br/>
            We may utilize a third party service such as Google Analytics to help Us gather and
            analyze this
            non personally identifying information as well as traffic and aggregated
            information. This helps Us
            improve the Services and to provide certain functionality, such as recognize your
            device when you use Our Services.<br/>
            <br/>
            <br/>
            <b>Information Use</b><br/>
            <br/>
            In general, We use the information collected from and about you on the Services in
            order to
            facilitate your use of and Our administration and operation of the Services, to
            provide
            support for the Services, to respond to user requests and inquiries, and to improve
            Our offerings.
            We will associate and analyze the information from and about users and their use of
            the Services
            to better understand what interests Our users.<br/>
            <br/>
            <br/>
            <b>Information Sharing</b><br/>
            <br/>
            We may share or disclose information about users (including personal information) as
            follows:<br/>
            <br/>
            Analytics. Like most websites We use third party analytic services to gather
            and analyze information through automated means. We engage third party providers
            such as Google Analytics
            to help Us track and analyze information from users of the Services.<br/>
            <br/>
            Service Providers. Information compiled from Our Services may also be shared with
            other service providers,
            like technical agents, subcontractors, and Our affiliates and consultants that are
            helping Us with Our Services.
            These intermediaries and data processors use your information in connection with
            performing the Services
            for which We have engaged them.<br/>
            <br/>
            Anonymized Information. We may freely share non personally identifying information
            and
            aggregated information from Our Services with others, such as merchants,
            advertisers,
            sponsors, potential investors and business partners for Our benefit and/or for their
            use.
            We may also provide them with reports that contain aggregated and statistical data
            for
            general marketing and demographic purposes. We also reserve the right to use
            anonymized
            data for any purpose including to disclose anonymized data to third parties.<br/>
            <br/>
            Investigations. We may disclose your information if permitted or required by law or
            is
            necessary to comply with the law enforcement or in response to a search warrant,
            subpoena
            or other legal process or where We believe such action is necessary in order to
            protect or
            defend Our interests or the interests of Our users or business partners.<br/>
            <br/>
            Business Transfers. We may share your information during due diligence or in
            preparation for a sale,
            merger, consolidation, change in control, transfer of substantial assets,
            reorganization or liquidation.
            In addition, if the business associated with the Services, or any of its assets, are
            sold,
            We retain the right to share and transfer all information described herein with a
            purchaser,
            so long as that purchaser agrees to abide by the terms of this Privacy Policy.<br/>
            <br/>
            <br/>
            <b>General</b><br/>
            <br/>
            Security. All of the user data is kept on infrastructure that We manage, using
            reasonable
            administrative, technical and physical safeguards designed to protect against
            unauthorized
            access or disclosure of data. Please be aware that no data transmission over the
            Internet
            or information contained in Our servers can be guaranteed to be 100% secure. As a
            result,
            while We strive to use commercially acceptable means to protect your information,
            We cannot guarantee or warrant its security.<br/><br/>

            Retention. We'll retain the information We collect on Our Servers for as long as We
            need
            it to provide you the Services. If you delete your account, We will also take steps
            to
            delete your user associated information. But please note: there might be some
            latency in
            deleting this information from Our servers and back-up storage; and We may retain
            this
            information if necessary to comply with Our legal obligations, resolve disputes, or
            enforce Our agreements.<br/>
            <br/>
            Children Under 13. Our Services are not intended for children under age 13.<br/>
            <br/>
            Around the world. Information may be maintained and transferred onto servers or
            databases
            located outside your state or country or to a jurisdiction where the privacy laws
            may be
            different from those in your location. If you are located outside of the United
            States,
            please be advised that We process and store information in the United States and
            your
            use of Our Services constitutes your consent to and understanding of this
            processing.<br/>
            <br/>
            California Privacy Rights. Under California law, California residents may be
            entitled to a notice
            describing what categories of personal customer information We have shared with
            third parties or
            corporate affiliates for direct marketing purposes in the past 12 months. If you are
            a California
            resident and would like a copy of this notice, please submit a written request to
            the address below.
            In your request, please specify: "California Privacy Notice." and allow up to thirty
            days for this notice to be provided.<br/>
            <br/>
            Marketing Opt Out. We permit all users to request an opt out from receiving
            marketing emails, texts,
            or other marketing communications from Us on a going-forward basis. Please submit a
            written
            request to the address below. In your request, please specify "Marketing Opt Out."
            Please note that if you opt out,
            this will apply to marketing messages from Us only. We will not be able to remove
            your personal information from
            the database of any third parties to whom you have previously authorized Us to share
            such information. Please
            also note that We may still send you important administrative messages, and you
            cannot opt-out from receiving
            such administrative messages.<br/>
            <br/>
            Changes. We may revise this Privacy Policy from time to time, and will post the most
            current
            version on Our website. If a revision meaningfully reduces your rights, We will
            notify you.<br/>
            <br/>
            This Privacy Policy shall be governed by and construed in accordance with the laws
            of the
            State of California applicable to agreements made and performed in California,
            excluding
            the application of the conflict of laws provisions. This Privacy Policy is also
            subject to Our Terms of Service.<br/>
            <br/>
            <br/>
            <b>Contact</b><br/>
            <br/>
            Have questions or concerns about Our Services and privacy? Contact Us at
            privacy@xosphere.io. Xosphere, Inc.<br/>
            <br/>
            Dated November 6, 2017
        </div>

    )
};

export default Privacy;